import type { IntlShape } from 'react-intl'
import type { ParticipantEditFieldOption } from '../../../domain/types'
import type { ParticipantEditFieldState, ParticipantEditPhoneNumbersFieldState } from '../../selectors'
import { getSupportedParticipantTitle } from '../participantName'

const GENDER_LABEL_KEYS: Record<string, string> = {
  Male: 'booking_details_participant_edit_gender_male_label',
  Female: 'booking_details_participant_edit_gender_female_label',
}

export type ParticipantEditOptionField = 'title' | 'gender'

type ParticipantEditField = ParticipantEditFieldState | ParticipantEditPhoneNumbersFieldState

export function getOptionLabelKey(fieldName: ParticipantEditOptionField, value: string): string | null {
  return fieldName === 'gender' ? GENDER_LABEL_KEYS[value] ?? null : getSupportedParticipantTitle(value)
}

export function toRadioItems(
  fieldName: ParticipantEditOptionField,
  options: ParticipantEditFieldOption[],
  formatMessage: IntlShape['formatMessage'],
) {
  return options.map(({ value, text }) => {
    const labelKey = getOptionLabelKey(fieldName, value)
    return { value, label: labelKey ? formatMessage({ id: labelKey }) : text }
  })
}

export function postalCodePattern(field: ParticipantEditFieldState, selectedCountryCode: string): string | undefined {
  return field.patternsByCountry[selectedCountryCode.toLowerCase()] ?? field.pattern
}

function notEditableHint(field: ParticipantEditField, formatMessage: IntlShape['formatMessage']): string | undefined {
  return field.notEditableHintKey ? formatMessage({ id: field.notEditableHintKey }) : undefined
}

export function fieldProps(
  field: ParticipantEditField,
  formatMessage: IntlShape['formatMessage'],
  hintKey?: string,
) {
  return {
    required: field.required,
    disabled: field.disabled,
    // Why the participant cannot change the field outweighs the hint on how to fill it in.
    helpText: notEditableHint(field, formatMessage) ?? (hintKey ? formatMessage({ id: hintKey }) : undefined),
  }
}
